import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../theme';
import { spaceBetween } from '../styles/mixins';
import { responsiveMdVsLg, responsiveSmVsMd } from '../styles/responsiveMixins';

const outsideShape = token => ({
  backgroundColor: ThemeColors.COLOR_WHITE3,
  border: `2px solid ${token.colorWhite}`,
  borderRadius: token.borderRadiusLG,
});

export const useChangelogDialogStyles = createStyles(({ token }) => ({
  changelogDialog: {
    '&&': {
      marginTop: 32,

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        width: '800px !important',
      },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          width: '500px !important',
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: '320px !important',
      },

      '.ant-modal-content': {
        ...outsideShape(token),
        filter: `drop-shadow(1px 6px 30px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.8)})`,
        boxShadow: 'none',
      },

      '.ant-modal-header': {
        ...outsideShape(token),
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomWidth: 0,

        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translate(-50%, -100%)',
        height: 40,

        ...responsiveSmVsMd({ width: 280 }, { width: 320 }),

        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '.ant-modal-title': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: token.fontSizeHeading4,
          fontWeight: 'bold',
          color: ThemeColors.COLOR_GREY3_5,

          '.QuickOnlineLogoQ': {
            marginRight: ThemeSpaces.SPACE_MD,
          },
        },
      },

      '.ant-modal-body': {
        height: 736,
        maxHeight: '80vh',
        padding: `${ThemeSpaces.SPACE_NORM}px 0`,
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  controlButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_NORM_15}px`,

    '> .ant-btn': {
      ...spaceBetween(ThemeSpaces.SPACE_NORM),
    },
  },

  content: {
    paddingTop: ThemeSpaces.SPACE_NORM_20,
    color: ThemeColors.COLOR_GREY_DARK2,
    fontSize: token.fontSizeLG,
    display: 'flex',
    flexDirection: 'column',

    ...responsiveMdVsLg(
      {
        paddingLeft: ThemeSpaces.SPACE_NORM,
        paddingRight: ThemeSpaces.SPACE_NORM,
      },
      { paddingLeft: ThemeSpaces.SPACE_XL, paddingRight: ThemeSpaces.SPACE_XL }
    ),

    a: {
      '&, &:link, &:visited': {
        color: ThemeColors.COLOR_BLUE2,
        textDecoration: 'underline',
      },
    },

    h1: {
      height: 32,
      lineHeight: '29px',
      textAlign: 'center',
      borderTop: `2px solid ${token.colorWhite}`,
      borderBottom: `1px solid ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH7, 0.35)}`,
      fontSize: token.fontSizeHeading4,
      fontWeight: 'bold',
      color: token.colorPrimary,
      textTransform: 'uppercase',

      ...responsiveMdVsLg(
        {
          marginLeft: -ThemeSpaces.SPACE_NORM,
          marginRight: -ThemeSpaces.SPACE_NORM,
        },
        {
          marginLeft: -ThemeSpaces.SPACE_XL,
          marginRight: -ThemeSpaces.SPACE_XL,
        }
      ),
    },

    'h2, h3': {
      fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
      lineHeight: 1,
      fontWeight: 300,
      textTransform: 'uppercase',
      marginBottom: ThemeSpaces.SPACE_NORM,
    },

    'ul, ol': {
      marginBottom: ThemeSpaces.SPACE_NORM_15,
      paddingLeft: 16 + ThemeSpaces.SPACE_NORM,
    },

    li: {
      paddingLeft: ThemeSpaces.SPACE_NORM_20 - 12,
    },

    img: {
      maxWidth: '100%',
      margin: 'auto',
    },
  },
}));
